const ICON_TIMES = 'times';
const ICON_PRESENT = 'present';
const ICON_RIBBON = 'ribbon';
const ICON_DOCS = 'docs';
const ICON_BELL = 'bell';
const ICON_TEAM = 'team';
const ICON_PENCIL = 'pencil';
const ICON_MEMBER = 'member';
const ICON_FORM = 'form';
const ICON_PHONE = 'phone';
const ICON_SUITCASE = 'suitcase';
const ICON_FIP = 'fiverr-pro';

type IconType =
    | typeof ICON_TIMES
    | typeof ICON_PRESENT
    | typeof ICON_RIBBON
    | typeof ICON_DOCS
    | typeof ICON_BELL
    | typeof ICON_TEAM
    | typeof ICON_PENCIL
    | typeof ICON_MEMBER
    | typeof ICON_FORM
    | typeof ICON_PHONE
    | typeof ICON_SUITCASE
    | typeof ICON_FIP;

interface NotificationTypes {
    [key: string]: IconType;
}

const types: NotificationTypes = {
    admin_moved_gig: ICON_PENCIL,
    and_co_announcement: ICON_PRESENT,
    audio_file_deny: ICON_PENCIL,
    business_accounts_team_invitation_accepted_invitee: ICON_TEAM,
    business_accounts_team_invitation_accepted_invitor: ICON_MEMBER,
    business_accounts_team_invitation_created: ICON_TEAM,
    workspaces_team_invitation_accepted: ICON_MEMBER,
    workspaces_team_invitation_created: ICON_TEAM,
    buyer_brief_notification_for_buyer_multi: ICON_DOCS,
    buyer_brief_notification_for_buyer_single: ICON_DOCS,
    buyer_brief_notification_for_buyer: ICON_DOCS,
    buyer_profile_reminder: ICON_FORM,
    buying_conversion_prediction_intervention_b: ICON_BELL,
    buying_conversion_prediction_intervention_c: ICON_BELL,
    buying_conversion_prediction_intervention: ICON_BELL,
    byob_user_notification: ICON_PRESENT,
    custom: ICON_PRESENT,
    delayed_private_review: ICON_PENCIL,
    buying_review_reminder: ICON_FORM,
    deny_user_notif: ICON_TIMES,
    featured_promotion: ICON_RIBBON,
    free_gig: ICON_PRESENT,
    gig_handpicked: ICON_RIBBON,
    gig_pro_toggled_off: ICON_DOCS,
    gig_pro_toggled_on: ICON_DOCS,
    id_verification_document_unrecognized: ICON_BELL,
    id_verification_failed: ICON_BELL,
    id_verification_indecisive_max_tries: ICON_BELL,
    id_verification_indecisive_try_again: ICON_BELL,
    id_verification_low_quality: ICON_BELL,
    id_verification_passed: ICON_BELL,
    level_down_notification: ICON_RIBBON,
    level_trs_kept_notification: ICON_RIBBON,
    level_trs_nominated_notification: ICON_RIBBON,
    level_two_kept_notification: ICON_RIBBON,
    level_up_notification: ICON_RIBBON,
    new_levels_system_notification: ICON_RIBBON,
    new_user_notification: ICON_DOCS,
    notify_user_on_referral_registration: ICON_PRESENT,
    optional_phone_verification: ICON_PHONE,
    pro_seller_account_created: ICON_DOCS,
    profile_image_not_unique_deleted: ICON_PENCIL,
    profile_image_not_unique_warning: ICON_PENCIL,
    prompt_user_change_password: ICON_DOCS,
    request_paused: ICON_DOCS,
    request_unapproved: ICON_TIMES,
    seo_restructure_announcement: ICON_PENCIL,
    shopping_balance_deposit_pending: ICON_PRESENT,
    shopping_balance_deposit_share: ICON_PRESENT,
    shopping_balance_deposit: ICON_PRESENT,
    soft_deny_user_notif: ICON_PENCIL,
    team_member_added: ICON_DOCS,
    trigger_id_verification: ICON_BELL,
    try_live: ICON_BELL,
    welcome_back_from_ooo_mode: ICON_SUITCASE,
    business_chat_added: ICON_BELL,
    pro_payment_way: ICON_FIP,
    identity_verification_passed: ICON_BELL,
    identity_verification_failed: ICON_BELL,
    identity_verification_seller_profession_auth_failed: ICON_BELL,
    identity_verification_failed_without_malice: ICON_BELL,
    identity_verification_failed_within_time_window: ICON_BELL,
    identity_verification_failed_start_time_window_to_be_not_eligible_to_sell: ICON_BELL,
    tracking_reminder_first_week_starts: ICON_BELL,
    tracking_reminder_2nd_week_starts: ICON_BELL,
    tracking_reminder_3rd_week_starts: ICON_BELL,
    hourly_order_completed_seller: ICON_BELL,
    hourly_order_completed_buyer: ICON_BELL,
    hourly_order_end_to_be: ICON_BELL,
    order_activated: ICON_BELL,
    hourly_limit_changed: ICON_BELL,
    order_paused: ICON_BELL,
    first_hours_tracked: ICON_BELL,
    hourly_report_updated: ICON_BELL,
    loyalty_credits_added: ICON_BELL,
    loyalty_credits_expired: ICON_BELL,
    loyalty_tier_upgrade_gold: ICON_BELL,
    loyalty_tier_upgrade_platinum: ICON_BELL,
    loyalty_tier_at_risk_downgrade: ICON_BELL,
    brief_new_match_created: ICON_BELL,
    ai_feedback_for_gig_available: ICON_BELL,
    seller_plus_enrollment_debt_indicated: ICON_BELL,
    seller_plus_enrollment_debt_final_warning: ICON_BELL,
    tier_subscription_trial_started_for_existing_silver_client: ICON_BELL,
    tier_subscription_trial_started_for_new_silver_client: ICON_BELL,
    tier_subscription_tier_upgrade_to_gold_during_essential: ICON_BELL,
    tier_subscription_tier_upgrade_to_platinum_during_essential: ICON_BELL,
    tier_subscription_tier_upgrade_to_gold_during_trial: ICON_BELL,
    tier_subscription_tier_upgrade_to_platinum_during_trial: ICON_BELL,
    tier_subscription_payment_failure: ICON_BELL,
    tier_subscription_member_requests_from_admin_to_subscribe_to_any_pro_plan: ICON_BELL,
    tier_subscription_essential_total_spent_step_reached: ICON_BELL,
    legal_documents_freelancer_signed_a_legal_document: ICON_BELL,
    legal_documents_agency_signed_a_legal_document: ICON_BELL,
    legal_documents_freelancer_need_to_sign_a_legal_document: ICON_BELL,
    legal_documents_refund_essential_tier_when_a_document_is_removed: ICON_BELL,
    workforce_classification_audit_requested_by_seller: ICON_BELL,
    workforce_classification_audit_requested_by_buyer: ICON_BELL,
    workforce_classification_audit_completed_by_seller: ICON_BELL,
    workforce_classification_audit_completed_by_buyer: ICON_BELL,
    workforce_classification_audit_expired_by_seller: ICON_BELL,
    workforce_classification_audit_expired_by_buyer: ICON_BELL,
    workforce_classification_audit_expired_by_buyer_credit: ICON_BELL,
    workforce_classification_audit_canceled_by_buyer: ICON_BELL,
    workforce_classification_audit_canceled_by_buyer_credit: ICON_BELL,
    background_check_requested_by_seller: ICON_BELL,
    background_check_requested_by_buyer: ICON_BELL,
    background_check_completed_by_seller: ICON_BELL,
    background_check_completed_by_buyer: ICON_BELL,
    background_check_refund_by_buyer: ICON_BELL,
    background_check_refund_by_buyer_credit: ICON_BELL,
    tier_subscription_subscribed_to_advanced: ICON_BELL,
    tier_subscription_subscribed_to_essential: ICON_BELL,
    member_requests_from_admin_to_upload_legal_templates: ICON_BELL,
    member_is_notified_that_admin_uploaded_legal_templates: ICON_BELL,
    tier_subscription_member_gets_update_on_request: ICON_BELL,
    hourly_weekly_payment_failed: ICON_BELL,
    client_in_debt_day_one: ICON_BELL,
    client_in_debt_days_two_four: ICON_BELL,
    client_in_debt_day_seven: ICON_BELL,
    hourly_weekly_payment_failed_seller: ICON_BELL,
    hourly_weekly_report_pending_approval_seller: ICON_BELL,
    hourly_weekly_report_approved_seller: ICON_BELL,
    hourly_weekly_report_review_and_approve_buyer: ICON_BELL,
    hourly_weekly_report_still_pending_approval_buyer: ICON_BELL,
    hourly_weekly_report_automatically_approved_buyer: ICON_BELL,
    seller_partial_refund_for_order: ICON_BELL,
    buyer_partial_refund_for_order: ICON_BELL,
    freelance_talent_recommendation_list_is_ready: ICON_BELL,
    freelance_talent_recommendation_list_was_updated: ICON_BELL,
    go_order_created_to_buyer: ICON_BELL,
    go_order_delivered_seller: ICON_BELL,
    go_order_completed_seller: ICON_BELL,
    go_order_revision_requested_seller: ICON_BELL,
    personal_assistant_conversation_invitation: ICON_BELL,
    fiverr_ads_tax_start_date_notification: ICON_BELL,
    seller_referral_opportunity: ICON_BELL,
    seller_referral_dashboard_activity: ICON_BELL,
    buyer_hourly_intent: ICON_BELL,
    legal_document_expired: ICON_BELL,
    promoted_ads_seller_becomes_ineligible: ICON_BELL,
    promoted_ads_seller_becomes_eligible_first_time: ICON_BELL,
    promoted_ads_seller_becomes_eligible_again: ICON_BELL,
    promoted_ads_gig_becomes_eligible_first_time: ICON_BELL,
    promoted_ads_profession_becomes_eligible_first_time: ICON_BELL,
    loyalty_tier_at_risk: ICON_BELL,
    loyalty_credits_about_to_expire: ICON_BELL,
    loyalty_credits_already_expired: ICON_BELL,
    loyalty_gift_cards_about_to_expire: ICON_BELL,
    loyalty_gift_cards_already_expired: ICON_BELL,
    loyalty_donations_about_to_expire: ICON_BELL,
    loyalty_donations_already_expired: ICON_BELL,
    loyalty_redeem_credits: ICON_BELL,
    loyalty_redeem_gift_cards: ICON_BELL,
    loyalty_donate_or_redeem: ICON_BELL,
    loyalty_points_added: ICON_BELL,
    loyalty_welcome_to_gold_tier: ICON_BELL,
    loyalty_welcome_to_platinum_tier: ICON_BELL,
    loyalty_welcome_to_diamond_tier: ICON_BELL,
    loyalty_tier_downgrade: ICON_BELL,
    fiverr_ads_seller_becomes_chargeable: ICON_BELL,
    loyalty_points_expire_in_90_days: ICON_BELL,
    domain_expert_sourcing_referred_buyer_messaged_you: ICON_BELL,
    new_lovable_message: ICON_BELL,
    new_embed_platform_message: ICON_BELL,
    fiverr_ads_blocked_due_to_debt: ICON_BELL,
    fiverr_ads_debt_warning: ICON_BELL,
    fiverr_ads_resumed_after_debt_settle: ICON_BELL,
};

export default types;
